import gql from 'graphql-tag';


const MUTATION_SEND_EDUCATOR_WELCOME_EMAIL = gql`
	mutation SendEducatorWelcomeEmail($userID: String!) {
		sendEducatorWelcomeEmail(userID: $userID)
	}
`;

export default MUTATION_SEND_EDUCATOR_WELCOME_EMAIL;